module.exports = __webpack_public_path__ + "static/media/modelD1.fda16721.gif";